export class Feature {
    constructor(public name: string, public value: string) {}
}
